import Api from "../../config/ApiConfig";
import * as types from "./types";
import * as functions from '../../components/shared/functions';


const apiUrls = {
    deleteInsituExtractor: "api/v1/extractors/insitu-criticality/delete",
    postInsituExt: "api/v1/extractors/insitu-criticality",
    getInsituExtractorDetail: "api/v1/extractors/insitu-criticality/detail",
    getInsituExtractorList: 'api/v1/searches/insitu-criticalities',
    putInsituExtractor: "api/v1/extractors/edit/insitu-criticality",
}

export const getInsituExtractorDetail = (params: string) =>
    Api.get(apiUrls.getInsituExtractorDetail + `/${params}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const putInsituExtractor = (param: any, payload: any) =>
    Api.put(apiUrls.putInsituExtractor + `/${param}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const getInsituExtractorList = (params: types.IInsituExtractorListParams) =>
    Api.get<types.IInsituExtractor[]>(apiUrls.getInsituExtractorList + "?skip=" + params.skip + "&count=" + params.count + "&orderby=" + params.orderby + "&top=" + params.top + "&queryType=full&search=" + params.search +
        functions.getParam(params.created_by, "createdBy") + functions.getParam(params.datasetName, "tableId"))
        .then((response) => {
            return response;
        })
        .catch((error) => { return error.response; });

export const postInsituExtractor = (params: types.IPostInsituExtractorRequest) =>
    Api.post(apiUrls.postInsituExt, params)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });


export const deleteInsituExtractor = (payload: string) =>
    Api.delete(apiUrls.deleteInsituExtractor + `/${payload}`)
        .then((response) => { return response })
        .catch((error) => {
            return error.response
        });